export default {
    factoryTestModal: {
        isOpen: false,
        isLoading: false,
        editingId: null,
        data: {
            id: null,
            type: null,
            project: null,
            order: null,
            address: '',
            assignee: null,
            description: '',
            time_range_start: '',
            time_range_end: '',
            creator: null,
            created_at: '',
            canceler: null,
            canceled_at: '',
            canceled_reason: '',
            approver: null,
            approved_at: '',
            approved_reason: '',
            rejecter: null,
            rejected_at: '',
            rejected_reason: '',
            attachments: [],
            newAttachments: [],
            service_times: [],
            status: null,
            performed_by: '',
            testing_pressure: '',
            observers_list: '',
            testings: [],
            inspections: [],
            testing_summary: '',
            tests: [],
            testsV2: [],
            testing_subjects: [],
            task_no: '',
            linked_task: '',
            custom_testing: '',
        },
        errors: {},
        autocomplete: {
            types: [],
            technicians: [],
            statuses: [],
            factoryTestReportsTypes: [],
            testingSubjects: [],
            testings: [],
        },
        actionWithReason: {
            isOpen: false,
            action: null,
            reason: '',
            errors: {},
        },
        newlyUploadedFiles: [],
        baseRoute: null,
    },
    testOpen: null,
    testV2Open: null,
    confirmation: {
        isOpen: false,
        title: '',
        text: '',
        accept: null,
        acceptText: null,
        cancel: null,
        cancelText: null,
    },
    factoryTestList: {
        refreshList: false,
        filtersOpen: false,
        filterData: {
            assignees: [],
            types: [],
            statuses: [],
            testingSubjects: [],
        },
        filters: {
            per_page: 10,
            only_my: false,
            filter: '',
            assignees: [],
            types: [],
            testingSubjects: [],
            statuses: [],
        },
    },
};
